<template>
  <!-- This component is not really used right now, because we cannot pass a slot with marker to leaflet as of now -->

  <!-- MPDT210068-3384: Use computed properties to change "path"-tags depending on the lights state -->
  <svg
    class="marker-legend"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 398.1 545.4"
  >
    <!-- MPDT210068-3384: Add new Error-Icon "path"-tag and choose depending on "markerIcon" which will be rendered-->

    <path
      id="marker"
      stroke="#000000"
      stroke-width="5"
      :fill="outlineColor"
      d="M10 199c0-67.7 52.9-189 189-189s189 123 189 189c0 132.1-165.5 336.4-189 336.4S10 334.4 10 199z"
    ></path>

    <g
      transform="
    translate(40 40)
    scale(0.8 0.8)"
    >
      <path
        id="innerMarker"
        stroke="#000000"
        stroke-width="5"
        :fill="markerBackgroundColor"
        d="M10 199c0-67.7 52.9-189 189-189s189 123 189 189c0 132.1-165.5 336.4-189 336.4S10 334.4 10 199z"
      ></path>
    </g>

    <g
      id="errorMarker"
      v-if="this.light.state === 'FAILURE'"
      transform="matrix(16.58 0 0 16.58 0 0)"
    >
      <path
        d="M12 5C 11.447715 5 11 5.4477153 11 6L11 6L11 14C 11 14.552285 11.447716 15 12 15C 12.552285 15 13 14.552285 13 14L13 14L13 6C 13 5.4477153 12.552285 5 12 5z"
        stroke="none"
        fill="#FFFFFF"
        fill-rule="nonzero"
      />
      <path
        d="M11 18C 11 17.447716 11.447715 17 12 17C 12.552285 17 13 17.447716 13 18C 13 18.552284 12.552285 19 12 19C 11.447715 19 11 18.552284 11 18z"
        stroke="none"
        fill="#FFFFFF"
        fill-rule="nonzero"
      />
    </g>
    <template v-else>
      <g
        v-if="light.type === 'SEGMENT'"
        transform="
    translate(40 40)
    scale(0.8 0.8)"
      >
        <path
          :stroke="bulbOutlineColor"
          stroke-width="10"
          :fill="bulbColor"
          d="M362 172.2c-0.8-5-2-9.8-3.7-14.3 -0.8-2.3-1.8-4.5-2.8-6.7 -2.1-4.4-4.6-8.5-7.5-12.3 -2.2-2.9-4.5-5.6-7.1-8.2 -0.8-0.8-1.7-1.7-2.6-2.5 -1.8-1.6-3.6-3.1-5.5-4.6 -3.8-2.9-8-5.4-12.3-7.5 -4.4-2.1-9-3.8-13.8-5 -6-1.5-12.3-2.4-18.7-2.4s-12.7 0.8-18.7 2.4c-0.2 0.1-0.4 0.1-0.6 0.2 17.1 17.5 27.6 41.5 27.6 67.8 0 31.4-15 60.5-40.2 78.8 0.2 0.5 0.3 1 0.4 1.4 0.2 0.8 0.3 1.6 0.4 2.4 0.1 0.4 0.1 0.8 0.1 1.2v0.5H319v-0.5c0-0.4 0.1-0.8 0.1-1.2 0.1-0.8 0.2-1.6 0.4-2.4 0.9-3.9 3-7.4 5.8-10.1 0.8-0.8 1.7-1.6 2.7-2.2 0.2-0.1 0.4-0.2 0.6-0.4 0.2-0.1 0.4-0.2 0.6-0.4 2.5-1.7 5-3.5 7.3-5.5 1.2-1 2.3-2 3.4-3 1.1-1 2.2-2.1 3.2-3.2 0.5-0.6 1-1.1 1.5-1.7 1-1.1 2-2.3 2.9-3.5 0.5-0.6 0.9-1.2 1.4-1.8 0.9-1.2 1.7-2.5 2.6-3.8 2.9-4.5 5.2-9.3 7.1-14.4 0.5-1.5 1-2.9 1.5-4.4 2-6.7 3-13.8 3-21.2C362.9 179.8 362.6 176 362 172.2z"
        ></path>
        <path
          :stroke="bulbOutlineColor"
          stroke-width="10"
          :fill="bulbColor"
          d="M257.1 270.8c0.7 16.5 14.3 29.6 30.9 29.6 16.6 0 30.2-13.1 30.9-29.6 0-0.5 0-0.9 0-1.4H257C257 269.9 257 270.3 257.1 270.8z"
        ></path>
        <path
          :stroke="bulbOutlineColor"
          stroke-width="10"
          :fill="bulbColor"
          d="M101.8 179.1c0-26.4 10.5-50.3 27.6-67.8 -0.2-0.1-0.4-0.1-0.6-0.2 -6-1.5-12.3-2.4-18.7-2.4s-12.7 0.8-18.7 2.4c-4.8 1.2-9.4 2.9-13.8 5 -4.4 2.1-8.5 4.6-12.3 7.5 -1.9 1.4-3.8 3-5.5 4.6 -0.9 0.8-1.8 1.6-2.6 2.5 -2.5 2.5-4.9 5.3-7.1 8.2 -2.9 3.8-5.4 8-7.5 12.3 -1.1 2.2-2 4.4-2.8 6.7 -1.7 4.6-2.9 9.4-3.7 14.3 -0.6 3.7-0.9 7.5-0.9 11.4 0 7.4 1.1 14.5 3 21.2 0.4 1.5 0.9 3 1.5 4.4 1.9 5.1 4.2 9.9 7.1 14.4 0.8 1.3 1.7 2.5 2.6 3.8 0.4 0.6 0.9 1.2 1.4 1.8 0.9 1.2 1.9 2.4 2.9 3.5 0.5 0.6 1 1.1 1.5 1.7 1 1.1 2.1 2.2 3.2 3.2 1.1 1 2.2 2.1 3.4 3 2.3 2 4.8 3.8 7.3 5.5 0.2 0.1 0.4 0.2 0.6 0.4 0.2 0.1 0.4 0.2 0.6 0.4 1 0.7 1.9 1.4 2.7 2.2 2.8 2.7 4.8 6.2 5.8 10.1 0.2 0.8 0.3 1.6 0.4 2.4 0.1 0.4 0.1 0.8 0.1 1.2v0.5H141v-0.5c0-0.4 0.1-0.8 0.1-1.2 0.1-0.8 0.2-1.6 0.4-2.4 0.1-0.5 0.3-1 0.4-1.4C116.7 239.6 101.8 210.4 101.8 179.1z"
        ></path>
        <path
          :stroke="bulbOutlineColor"
          stroke-width="10"
          :fill="bulbColor"
          d="M79.1 270.8c0.7 16.5 14.3 29.6 30.9 29.6s30.2-13.1 30.9-29.6c0-0.5 0-0.9 0-1.4H79.1C79.1 269.9 79.1 270.3 79.1 270.8z"
        ></path>
        <path
          :stroke="bulbOutlineColor"
          stroke-width="10"
          :fill="bulbColor"
          d="M288.4 160.7c-0.5-2.2-1-4.4-1.6-6.6 -0.4-1.4-0.9-2.9-1.3-4.3 -1.2-3.5-2.6-7-4.2-10.3 -0.6-1.3-1.3-2.6-2-3.9 -1.1-1.9-2.2-3.8-3.4-5.7 -0.8-1.2-1.6-2.4-2.5-3.6s-1.7-2.4-2.6-3.5c-2.6-3.4-5.5-6.5-8.6-9.5 -0.2 0.1-0.7 0.1-1.4 0.2 0.7 0 1.2-0.1 1.4-0.2 -0.1-0.1-0.2-0.2-0.3-0.3 -1.1-1-2.1-2-3.2-2.9 -0.5-0.4-1-0.8-1.5-1.3 -0.6-0.5-1.3-1-1.9-1.5 -1.1-0.9-2.3-1.8-3.5-2.6 -1.8-1.3-3.6-2.5-5.5-3.6 -1.3-0.8-2.5-1.5-3.8-2.2 -12.9-7-27.8-11-43.5-11s-30.6 4-43.5 11c-1.3 0.7-2.6 1.4-3.8 2.2 -1.9 1.1-3.7 2.4-5.5 3.6 -1.2 0.8-2.4 1.7-3.5 2.6 -0.6 0.5-1.3 1-1.9 1.5 -0.5 0.4-1 0.8-1.5 1.3 -1.1 1-2.2 1.9-3.2 2.9 -0.1 0.1-0.2 0.2-0.3 0.3h0c-3.1 3-5.9 6.1-8.6 9.5 -0.9 1.1-1.8 2.3-2.6 3.5s-1.7 2.4-2.5 3.6c-1.2 1.9-2.3 3.7-3.4 5.7 -0.7 1.3-1.4 2.6-2 3.9 -1.6 3.3-3 6.8-4.2 10.3 -0.5 1.4-0.9 2.8-1.3 4.3 -0.6 2.2-1.2 4.4-1.6 6.6 -1.2 5.9-1.9 12.1-1.9 18.4 0 8 1 15.7 2.9 23.1 0.5 1.8 1 3.7 1.6 5.5 0.6 1.8 1.2 3.6 1.9 5.3 2.1 5.2 4.7 10.2 7.6 14.9 1 1.6 2 3.1 3.1 4.6 0.5 0.8 1.1 1.5 1.7 2.2 1.1 1.5 2.3 2.9 3.5 4.3 0.6 0.7 1.2 1.4 1.9 2.1 1.3 1.4 2.6 2.7 3.9 4 1.3 1.3 2.7 2.5 4.1 3.7 1.5 1.3 3 2.5 4.6 3.7 1.4 1 2.8 2 4.3 3 0.2 0.1 0.4 0.3 0.7 0.4 0.2 0.1 0.5 0.3 0.7 0.4 2.3 1.6 4.4 3.6 6.1 5.9 0.6 0.8 1.1 1.6 1.6 2.4s0.9 1.7 1.3 2.6c1.1 2.6 1.9 5.5 2.1 8.5v1.9h75.5v-1.9c0.2-3 0.9-5.9 2.1-8.5 0.4-0.9 0.8-1.7 1.3-2.6 0.5-0.8 1-1.6 1.6-2.4 1.7-2.3 3.7-4.3 6.1-5.9 0.2-0.2 0.5-0.3 0.7-0.4 0.2-0.1 0.4-0.3 0.7-0.4 1.5-1 2.9-2 4.3-3 1.6-1.2 3.1-2.4 4.6-3.7 1.4-1.2 2.8-2.4 4.1-3.7s2.6-2.6 3.9-4c0.6-0.7 1.2-1.4 1.9-2.1 1.2-1.4 2.4-2.8 3.5-4.3 0.6-0.7 1.1-1.5 1.7-2.2 1.1-1.5 2.1-3 3.1-4.6 3-4.7 5.5-9.7 7.6-14.9 0.7-1.7 1.3-3.5 1.9-5.3 0.6-1.8 1.1-3.6 1.6-5.5 1.9-7.4 2.9-15.1 2.9-23.1C290.3 172.8 289.7 166.6 288.4 160.7z"
        ></path>
        <path
          :stroke="bulbOutlineColor"
          stroke-width="10"
          :fill="bulbColor"
          d="M161.3 284c0.2 20.7 17 37.3 37.7 37.3s37.5-16.7 37.7-37.3c0-0.1 0-0.3 0-0.4h-75.5C161.3 283.7 161.3 283.8 161.3 284z"
        ></path>
      </g>
      <g v-else id="bulb" transform="translate(0 20)">
        <path
          id="upperBulb"
          stroke-width="10"
          :stroke="bulbOutlineColor"
          :fill="bulbColor"
          d="M199 87.8c-50.4 0-91.3 40.9-91.3 91.3 0 31.9 16.4 60 41.2 76.3 0.5 0.3 0.9 0.6 1.4 0.9 6.2 4.3 10.5 11.4 11 19.4v2.3h0H199h37.7 0v-2.3c0.5-8 4.7-15.1 11-19.4 0.4-0.3 0.9-0.6 1.4-0.9 24.8-16.3 41.2-44.4 41.2-76.3C290.3 128.7 249.4 87.8 199 87.8z"
        ></path>
        <path
          id="lowerBulb"
          stroke-width="10"
          :stroke="bulbOutlineColor"
          :fill="bulbColor"
          d="M199 321.3c20.8 0 37.7-16.9 37.7-37.7h-75.5C161.3 304.4 178.2 321.3 199 321.3z"
        ></path>
      </g>
    </template>
  </svg>
</template>
<script>
export default {
  props: {
    light: {
      type: Object,
      required: true
    },
    showMissingFeedback: {
      type: Boolean,
      required: false,
      default: function() {
        return false;
      }
    }
  },
  computed: {
    // MPDT210068-3384: change this depending on the group color
    outlineColor() {
      if (this.light.group === undefined) return "#000000"; // Then there is no group
      return this.light.group.color; // Group color
    },
    markerBackgroundColor() {
      if (this.light.state === "FAILURE") {
        return "#FF1744";
      }

      if (!this.light.dimValueConfirmed && this.showMissingFeedback)
        return "orange"; // Marker background error color
      return "#CCCCCC"; // Marker background color
    },
    // MPDT210068-3384: change this depending on the dimness intensity (0%: grey -> 100%: yellow)
    bulbColor() {
      function hslToHex(h, s, l) {
        l /= 100;
        const a = (s * Math.min(l, 1 - l)) / 100;
        const f = n => {
          const k = (n + h / 30) % 12;
          const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
          return Math.round(255 * color)
            .toString(16)
            .padStart(2, "0"); // convert to Hex and prefix "0" if needed
        };
        return `#${f(0)}${f(8)}${f(4)}`;
      }
      let dim = this.light.dimValue;
      if (dim === 0) return "#000000";
      return hslToHex(60, dim / 2 + 50, 70); //'#FFFF00';
    },
    bulbOutlineColor() {
      return this.bulbColor === "#000000" ? "#FFFFFF" : "#000000";
    }
  }
};
</script>

<style>
.marker-legend {
  width: 1.5em;
  margin-right: 0.5em;
}
</style>
